module.exports = __webpack_public_path__ + "static/img/2017-04-08 13.56.13-1.24bcd32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/2017-04-08 13.56.13-1.jpg
// module id = 4hgZ
// module chunks = 4